// @ts-nocheck
import store from "../../../../store"
import { Network } from "../../.."
import { Expense } from "../customer"
import api from "../../../../../api/axios"

export default class ExpenseApproval extends Expense {
	static async getExpenses({ params }) {
		try {
			const url = `expense/review?${params}`
			const response = await api.get(url)

			let users = response?.data?.included?.users
			users = users.map((user) => [user.id, new Network.API.Profile.User({ ...user, insurance: {} })])
			users = new Map(users)

			const expenses = response?.data?.data.map((expense, index) => {
				expense = new ExpenseApproval({ ...expense, index, user: users.get(expense.userId) })
				return [index, expense]
			})

			return new Map(expenses)
		} catch (error) {
			console.error(error)
		}
	}

	static async getExpense({ expense }) {
		const url = expense?.links?.getDetail?.url
		const response = await api.get(url)
		const expenseDetails = response?.data

		return new ExpenseApproval({
			...expenseDetails,
			user: new Network.API.Profile.User({ ...expenseDetails.user })
		})
	}

	static async getTextImages({ params }) {
		try {
			const url = `expense/review/textImage?${params}`
			const response = await api.get(url)
			const textImages = new Map(
				response.data?.data?.map((obj, index) => {
					// Create a new object to avoid modifying the original 'data' array objects directly.
					// Use the spread operator (...) to copy existing properties.
					const newObj = { ...obj, index: index };
					return [index, newObj]; // Key is the index, value is the new object with 'originalIndex'
				})
			);
			return textImages
		} catch (error) {
			console.error(error)
		}
	}

	static async getTextImage({ textImage }) {
		// console.log("Getting TextImage, textImage = ", textImage)
		const url = `expense/review/textImage/${textImage.id}`
		const response = await api.get(url)
		const textImageDetails = response?.data
		console.log("TextImageDetails = ", textImageDetails)

		return textImageDetails
	}

	static async getExpenseEmails({ params }) {
		try {
			const url = `expense/email/review?${params}`
			const response = await api.get(url)

			let users = response?.data?.included?.users
			users = users.map((user) => [user.id, new Network.API.Profile.User({ ...user, insurance: {} })])
			users = new Map(users)

			const expenses = response?.data?.data.map((expense, index) => {
				expense = new ExpenseApproval({ ...expense, index, user: users.get(expense.userId) })
				return [index, expense]
			})

			return new Map(expenses)
		} catch (error) {
			console.error(error)
		}
	}

	static async getExpenseEmail({ expenseEmail }) {
		const url = expenseEmail?.links?.getDetail?.url
		const response = await api.get(url)
		const expenseEmailDetails = response?.data

		return new ExpenseApproval({
			...expenseEmailDetails,
			user: new Network.API.Profile.User({ ...expenseEmailDetails.user })
		})
	}

	static async updateExpense({ params: { link, msg }, payload }) {
		const { url, method } = link
		const { data: expenseDetails } = await Network.AxiosWrapperV2.send({ url, method, data: payload })
		store.setNotification("notification", true, { msg })

		return new ExpenseApproval({ ...expenseDetails, expenseDetails })
	}
	static async updateExpenseEmail({ params: { link, msg }, payload }) {
		const { url, method } = link
		const { data: expenseEmailDetails } = await Network.AxiosWrapperV2.send({ url, method, data: payload })
		store.setNotification("notification", true, { msg })

		return new ExpenseApproval({ ...expenseEmailDetails, expenseEmailDetails })
	}

	get firstAllocation() {
		return this?.allocations?.[0]
	}
}
